import React, { useContext } from "react";
import {
  ACTION,
  PatientPreferredInput,
  RequestListReducerActionTypes,
  RequestListState,
  RequestListType,
} from "./PotentialReceiverTableReducer";

type PotentialReceiverContextType = {
  deselectAllRequests: () => void;
  getRequestState: (id: number) => RequestListType | undefined;
  requestListState: RequestListState;
  setAutomaticSearch: () => void;
  setPatientPreferred: (value: PatientPreferredInput) => void;
  setRequest: (id: number) => void;
};

export const PotentialReceiverContext =
  React.createContext<PotentialReceiverContextType>({
    deselectAllRequests: () => {},
    getRequestState: () => undefined,
    requestListState: { automaticSearch: false, requestFormState: {} },
    setAutomaticSearch: () => {},
    setPatientPreferred: () => {},
    setRequest: () => {},
  });

export function usePotentialReceiverContext(): PotentialReceiverContextType {
  return useContext(PotentialReceiverContext);
}

export function PotentialReceiverContextProvider({
  children,
  dispatch,
  requestListState,
}: {
  children: React.JSX.Element;
  dispatch: React.Dispatch<RequestListReducerActionTypes>;
  requestListState: RequestListState;
}) {
  return (
    <PotentialReceiverContext.Provider
      value={{
        deselectAllRequests: () => {
          dispatch({ type: ACTION.DESELECT_ALL_REQUESTS });
        },
        getRequestState: (id: number): RequestListType => {
          const state = requestListState.requestFormState?.[id];
          if (!state) {
            return {
              careprovider_id: -1,
              id,
              manually_selected: false,
              patient_preferred: false,
              patient_preferred_reason: undefined,
            };
          }
          return state;
        },
        requestListState,
        setAutomaticSearch: () => {
          dispatch({
            type: ACTION.SET_AUTOMATIC_SEARCH,
          });
        },
        setPatientPreferred: (payload: PatientPreferredInput) => {
          dispatch({ payload, type: ACTION.SET_PATIENT_PREFERRED });
        },
        setRequest: (id: number) => {
          dispatch({ payload: { id }, type: ACTION.SET_REQUEST });
        },
      }}
    >
      {children}
    </PotentialReceiverContext.Provider>
  );
}
